/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const OpeningTime: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M18 24C19.1867 24 20.3467 23.6481 21.3334 22.9888C22.3201 22.3295 23.0892 21.3925 23.5433 20.2961C23.9974 19.1997 24.1162 17.9933 23.8847 16.8295C23.6532 15.6656 23.0818 14.5965 22.2426 13.7574C21.4035 12.9182 20.3344 12.3468 19.1705 12.1153C18.0067 11.8838 16.8003 12.0026 15.7039 12.4567C14.6075 12.9109 13.6705 13.6799 13.0112 14.6666C12.3519 15.6533 12 16.8133 12 18C12 19.5913 12.6321 21.1174 13.7574 22.2426C14.8826 23.3679 16.4087 24 18 24ZM17 14H19V17H22V19H17V14Z'
      fill='currentColor'
    />
    <path
      d='M23 3H18V1C18 0.734784 17.8946 0.48043 17.7071 0.292893C17.5196 0.105357 17.2652 0 17 0C16.7348 0 16.4804 0.105357 16.2929 0.292893C16.1054 0.48043 16 0.734784 16 1V3H8V1C8 0.734784 7.89464 0.48043 7.70711 0.292893C7.51957 0.105357 7.26522 0 7 0C6.73478 0 6.48043 0.105357 6.29289 0.292893C6.10536 0.48043 6 0.734784 6 1V3H1C0.734784 3 0.48043 3.10536 0.292893 3.29289C0.105357 3.48043 0 3.73478 0 4L0 22C0 22.2652 0.105357 22.5196 0.292893 22.7071C0.48043 22.8946 0.734784 23 1 23H10V21H2V7H22V11H24V4C24 3.73478 23.8946 3.48043 23.7071 3.29289C23.5196 3.10536 23.2652 3 23 3Z'
      fill='currentColor'
    />
  </React.Fragment>
)
